import React from "react";
import BlogCard from "../components/BlogCard";
import "../components/blog.css";
import blogData from "../data/BlogData";
import { Link } from "react-router-dom";
import BlogBanner from "../assests/image/blog banner.webp";
import NewFAQ from "../components/NewFAQ";



const Blog = () => {
  return (
    <>
      <div
        className="inner-banner"
        style={{
          background: `url(${BlogBanner}) center center no-repeat`,
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row inner-title text-center">
            <div className="col-lg-6">
              <div className="about-widget-img breadcrumb-itd">
                <h3>Our Latest Blogs</h3>
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>
                  </li>
                  <li>Blog</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
     <div className="blog-title">Hospital Management Software</div>
      <div className="blog-container">
        <div className="blog-grid">
          {blogData.map((blog) => (
            <BlogCard key={blog.slug} blog={blog} />
          ))}
        </div>
      </div>
      {/* <NewFAQ faqKey="billing" /> */}
    </>
  );
};

export default Blog;
